import React, { useState, useMemo } from 'react';

import {
  VirtualizedList,
  SidePage,
  Button,
  Divider,
  Grid,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import {
  CreateInfluencer,
  UpdateInfluencer,
} from 'scenes/Influencers/InfluencersChannels/components/InfluencerForm';

import { useLoadInfluencers } from '../../data';
import SearchField from './SearchField';
import InfluencerActions from './components/Actions';

const Influencers = ({ onClose, onExited, open }) => {
  const { data: influencers, isLoading, isRefetching } = useLoadInfluencers();
  const [searchQuery, setSearchQuery] = useState('');
  const [childComponent, openChildComponent] = useChildComponent();

  const filteredData = useMemo(() => {
    if (!influencers?.data) {
      return [];
    }
    const queryKey = searchQuery.toUpperCase();
    return searchQuery.length
      ? influencers?.data.filter(({ name }) =>
          name.toUpperCase().includes(queryKey)
        )
      : influencers?.data;
  }, [influencers, searchQuery]);

  const handleAdd = () => {
    openChildComponent(CreateInfluencer);
  };

  const handleEdit = (initialValues) => {
    openChildComponent(UpdateInfluencer, { initialValues });
  };

  return (
    <SidePage
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={isLoading || isRefetching}
      size={'md'}
    >
      <SidePage.Title title={'Influencers'} />
      <SidePage.NewBody fullHeight={false} scroll={false} disableGutters>
        <Grid container spacing={1} style={{ padding: '0 16px' }}>
          <Grid item xs={12}>
            <SearchField onChange={setSearchQuery} />
          </Grid>
          <Grid item xs={12}>
            <Button add onClick={handleAdd}>
              Influencer
            </Button>
          </Grid>
        </Grid>
      </SidePage.NewBody>
      <Divider />
      <SidePage.NewBody scroll={false} disableGutters>
        {filteredData ? (
          <VirtualizedList
            divider={false}
            data={filteredData}
            button={false}
            withSearch={!!searchQuery}
            secondaryAction={({ actions, ...item }) => {
              return (
                <InfluencerActions
                  actions={actions}
                  data={item}
                  onEdit={handleEdit}
                />
              );
            }}
          />
        ) : null}
        {childComponent}
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
    </SidePage>
  );
};

export default Influencers;
